<div class="flex flex-col gap-3">
  <label class="flex flex-col gap-2">
    <span class="flex items-baseline justify-between">
      <span class="font-bold">Zeilen</span>
      <span class="text-theme-gray-800 tabular-nums">{{ rowCount() }}</span>
    </span>
    <input
      type="range"
      class="w-full"
      data-testid="dev-tools-row-count"
      [min]="minRowCount"
      [max]="maxRowCount"
      [value]="rowCount()"
      (input)="onRowCountInput($any($event.target).value)" />
    <span class="text-theme-gray-700 flex justify-between text-xs">
      <span>{{ minRowCount }}</span>
      <span>{{ maxRowCount }}</span>
    </span>
  </label>

  @if (hasSum()) {
    <fieldset class="flex flex-col gap-2">
      <legend class="mb-2 font-bold">Summe</legend>
      @for (option of sumModes; track option.mode) {
        <label class="flex items-center gap-2">
          <input
            type="radio"
            name="sum-mode"
            [attr.data-testid]="'dev-tools-sum-mode-' + option.mode"
            [value]="option.mode"
            [checked]="sumMode() === option.mode"
            (change)="sumMode.set(option.mode)" />
          <span>{{ option.label }}</span>
        </label>
      }
    </fieldset>
  }

  <div class="grid grid-cols-2 gap-2">
    <button
      type="button"
      class="bg-theme-blue rounded px-2 py-1.5 text-xs font-bold text-white uppercase hover:opacity-90"
      data-testid="dev-tools-fill-all"
      (click)="generate('all')">
      Alle Felder
    </button>

    <button
      type="button"
      class="border-theme-gray-500 text-theme-gray-800 hover:bg-theme-blue-gray rounded border px-2 py-1.5 text-xs font-bold uppercase"
      data-testid="dev-tools-fill-required"
      (click)="generate('required')">
      Nur Pflichtfelder
    </button>
  </div>

  <button
    type="button"
    class="border-theme-gray-500 text-theme-gray-800 hover:bg-theme-blue-gray w-full rounded border px-2 py-1.5 text-xs font-bold uppercase"
    data-testid="dev-tools-remove-all"
    (click)="removeAll()">
    Alle Zeilen entfernen
  </button>
</div>
